// @flow
import * as React from "react";

import { ConfigProvider, theme } from "antd";
import ENGLISH_GB_LOCALE from "antd/locale/en_GB";

import "./lib/dayjs";

const THEME = {
  algorithm: theme.compactAlgorithm,
};

type Props = {
  children: React.Node,
};

function AntdConfigProvider({ children }: Props): React.Node {
  return (
    <ConfigProvider locale={ENGLISH_GB_LOCALE} theme={THEME}>
      {children}
    </ConfigProvider>
  );
}

export default AntdConfigProvider;
